/**
 * SPEC-009 SIM-PRINCIPLE-004/§77/§78/SIM-REQ-013 — reverse requirements for
 * countable volumes (people/leads/clients) always ceil; the explanation
 * always shows both the raw and rounded value so the ceiling is visible,
 * never silent.
 */
export interface RoundedRequirement {
  rawRequired: number;
  roundedRequired: number;
  rounding: 'ceiling' | 'none';
}

export function ceilRequirement(rawRequired: number): RoundedRequirement {
  const roundedRequired = Math.ceil(rawRequired);
  return { rawRequired, roundedRequired, rounding: roundedRequired === rawRequired ? 'none' : 'ceiling' };
}
